export const payee = [
    {
        value: "Use portfolio"
    }
];

export const months = [
    {
        value: "January"
    },
    {
        value: "Febuary"
    },
    {
        value: "March"
    },
    {
        value: "April"
    },
    {
        value: "May"
    },
    {
        value: "June"
    },
    {
        value: "July"
    },
    {
        value: "August"
    },
    {
        value: "September"
    },
    {
        value: "Octuber"
    },
    {
        value: "November"
    },
    {
        value: "December"
    },

];

export const packets = [
    {
        value: "Cash"
    },
    {
        value: "Accrual"
    }
];